import {HttpClient} from "@angular/common/http";
import {inject} from "@angular/core";
import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";


export const userHandlingStore = signalStore(
    {providedIn: 'root'},
    withState({
        user: null,
    }),
    withMethods((store, http = inject(HttpClient)) => ({
        setUser(user: any) {
          patchState(store, {user});
        },
        fetchUser(id: number) {
            return new Promise((resolve)=> http.get<any>(`/api/loginUser/${id}`)
                .subscribe((user)=> {this.setUser(user);resolve(user)})
            )
        },
        clearUser(){

        }
    }))
);